export const get_ranking = (rank) => {
  let ratingval = rank;
  let fullcount = "";
  let quatercount = "";
  let halfcount = "";
  let emptycount = "";
  let quaterhalf = "";

  if (ratingval >= 1 && ratingval <= 1.12) {
    fullcount = 1;
    quatercount = 0;
    halfcount = 0;
    emptycount = 4;
    quaterhalf = 0;
  } else if (ratingval >= 1.13 && ratingval <= 1.37) {
    fullcount = 1;
    quatercount = 1;
    halfcount = 0;
    emptycount = 3;
    quaterhalf = 0;
  } else if (ratingval >= 1.38 && ratingval <= 1.62) {
    fullcount = 1;
    quatercount = 0;
    halfcount = 1;
    emptycount = 3;
    quaterhalf = 0;
  } else if (ratingval >= 1.63 && ratingval <= 1.86) {
    fullcount = 1;
    quatercount = 0;
    halfcount = 0;
    emptycount = 3;
    quaterhalf = 1;
  } else if (ratingval >= 1.87 && ratingval <= 2.12) {
    fullcount = 2;
    quatercount = 0;
    halfcount = 0;
    emptycount = 3;
    quaterhalf = 0;
  } else if (ratingval >= 2.13 && ratingval <= 2.37) {
    fullcount = 2;
    quatercount = 1;
    halfcount = 0;
    emptycount = 2;
    quaterhalf = 0;
  } else if (ratingval >= 2.38 && ratingval <= 2.62) {
    fullcount = 2;
    quatercount = 0;
    halfcount = 1;
    emptycount = 2;
    quaterhalf = 0;
  } else if (ratingval >= 2.63 && ratingval <= 2.86) {
    fullcount = 2;
    quatercount = 0;
    halfcount = 0;
    emptycount = 2;
    quaterhalf = 1;
  } else if (ratingval >= 2.87 && ratingval <= 3.12) {
    fullcount = 3;
    quatercount = 0;
    halfcount = 0;
    emptycount = 2;
    quaterhalf = 0;
  } else if (ratingval >= 3.13 && ratingval <= 3.37) {
    fullcount = 3;
    quatercount = 1;
    halfcount = 0;
    emptycount = 1;
    quaterhalf = 0;
  } else if (ratingval >= 3.38 && ratingval <= 3.62) {
    fullcount = 3;
    quatercount = 0;
    halfcount = 1;
    emptycount = 1;
    quaterhalf = 0;
  } else if (ratingval >= 3.63 && ratingval <= 3.86) {
    fullcount = 3;
    quatercount = 0;
    halfcount = 0;
    emptycount = 1;
    quaterhalf = 1;
  } else if (ratingval >= 3.87 && ratingval <= 4.12) {
    fullcount = 4;
    quatercount = 0;
    halfcount = 0;
    emptycount = 1;
    quaterhalf = 0;
  } else if (ratingval >= 4.13 && ratingval <= 4.37) {
    fullcount = 4;
    quatercount = 1;
    halfcount = 0;
    emptycount = 0;
    quaterhalf = 0;
  } else if (ratingval >= 4.38 && ratingval <= 4.62) {
    fullcount = 4;
    quatercount = 0;
    halfcount = 1;
    emptycount = 0;
    quaterhalf = 0;
  } else if (ratingval >= 4.63 && ratingval <= 4.86) {
    fullcount = 4;
    quatercount = 0;
    halfcount = 0;
    emptycount = 0;
    quaterhalf = 1;
  } else if (ratingval >= 4.87) {
    fullcount = 5;
    quatercount = 0;
    halfcount = 0;
    emptycount = 0;
    quaterhalf = 0;
  }

  return [fullcount, quatercount, halfcount, emptycount, quaterhalf];
};
